export const ROOT_DOMAIN = 'https://vpodberaku.sk'

export const ROUTE_SIGN_IN = '/sign-in'
export const ROUTE_SIGN_UP = '/sign-up'
export const ROUTE_SIGN_OUT = '/sign-out'
export const ROUTE_HOME = '/'
export const ROUTE_ADMIN = '/admin'
export const ROUTE_SESSION_DETAIL = (id: string) => `/sessions/${id}`
export const ROUTE_SESSION_DETAIL_TAB = (id: string, tab: string) => `/sessions/${id}?tab=${tab}`
export const ROUTE_CATCH_DETAIL = (sessionId: string, catchId: string) =>
  `${ROUTE_SESSION_DETAIL(sessionId)}/catches/${catchId}`
export const ROUTE_PHOTO_ALBUM_DETAIL = (sessionId: string, albumId: string) =>
  `${ROUTE_SESSION_DETAIL(sessionId)}/photo-albums/${albumId}`
export const ROUTE_PUBLIC_PHOTO_ALBUM_ROOT = '/public-content/photo-albums'
export const ROUTE_PUBLIC_PHOTO_DETAIL_ROOT = '/public-content/photos'
export const ROUTE_PHOTO_ALBUMS = '/photo-albums'
export const ROUTE_NOTES = '/notes'
export const ROUTE_NOTE_DETAIL = (id: string) => `/notes/${id}`
export const ROUTE_NOTE_NEW = '/notes/new'
export const ROUTE_NOTE_EDIT = (id: string) => `/notes/${id}/edit`
export const ROUTE_COPYRIGHT_POLICY = '/copyright-policy'
export const ROUTE_COOKIE_POLICY = '/cookie-policy'
export const ROUTE_TERMS_AND_CONDITIONS = '/terms-and-conditions'
export const ROUTE_PRIVACY_POLICY = '/privacy-policy'
export const ROUTE_FORGOT_PASSWORD = '/forgot-password'
export const ROUTE_RESET_PASSWORD = '/reset-password'

export const PUBLIC_ROUTES = [
  ROUTE_SIGN_IN,
  ROUTE_SIGN_UP,
  ROUTE_PUBLIC_PHOTO_ALBUM_ROOT,
  ROUTE_PUBLIC_PHOTO_DETAIL_ROOT,
  ROUTE_COOKIE_POLICY,
  ROUTE_TERMS_AND_CONDITIONS,
  ROUTE_PRIVACY_POLICY,
  ROUTE_COPYRIGHT_POLICY,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_RESET_PASSWORD,
]

export const openInTab = (url: string) => url && window.open(url, '_blank')
